<template>
  <div class="app-container bg-f3f4f7" style="padding: 10px 20px 20px">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
        <div class="tab-item active">
          <span class="bg-4-f5971d"></span>
          公司定义
        </div>
      </div>
    </div>
    <div class="mb-10 flex">
      <div class="btn-24-bg-ff flex align-center mr-5" @click="onAdd">
        <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
        新增
      </div>
    </div>
    <div class="flex-1">
      <div class="h-100 flex-column">
        <div class="flex-1 mb-10">
          <div class="h-100">
            <erp-table :table-data="tableData" :column-data="columnData" ref="erpTable" @on-modify="onModify" modify-method="on-modify" :is-edit="true"></erp-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErpTable from '../../components/ErpTable'
export default {
  name: 'CompanyDefine',
  components: {ErpTable},
  data () {
    return {
      tableData: [],
      columnData: [
        // {
        //   field: 'isModified',
        //   title: '启用',
        //   width: '60',
        //   isDefine: true,
        //   child: [{
        //     title: '是',
        //     key: 'isModified',
        //     methodName: 'on-change-modify',
        //     type: 'radio',
        //     activeValue: 1,
        //     inactiveValue: -1
        //   }]
        // }
        {
          field: 'name',
          title: '公司名称',
          width: '350',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'code',
          title: '公司编码',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ]
    }
  },
  created () {
    this.getCompany()
  },
  methods: {
    getCompany () {
      this.axios.post('company/listForAll', {}).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    },
    onAdd () {
      this.axios.post('company/save', {}).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onModify (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('company/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/companyDefine.vue